/**
 * Client for the tournament meta + deck database endpoints.
 *
 * Everything here is precomputed server-side by the pipeline's meta_rollup job,
 * so these are plain reads — no aggregation happens in the browser.
 */

async function getJson(url) {
  const res = await fetch(url);
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = await res.json();
      message = body.error || body.message || message;
    } catch {
      /* non-JSON error body; keep the status message */
    }
    const error = new Error(message);
    error.status = res.status;
    throw error;
  }
  return res.json();
}

function toQuery(params = {}) {
  const qs = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  }
  const str = qs.toString();
  return str ? `?${str}` : '';
}

/** Full meta rollup: coverage, archetype table, weekly trend, top cards, regions. */
export function fetchMetaSummary(params = {}) {
  return getJson(`/api/meta/summary${toQuery(params)}`);
}

/** Ranked archetype table only. */
export function fetchArchetypes(params = {}) {
  return getJson(`/api/meta/archetypes${toQuery(params)}`);
}

/** Browse/filter tournament decklists. Paging is cursor-ish: the response
 *  carries `hasMore` rather than a total, so no caller learns the corpus size. */
export function fetchTournamentDecks(params = {}) {
  return getJson(`/api/decks/tournament${toQuery(params)}`);
}

/** One decklist, localized against the card catalog. */
export function fetchTournamentDeck(code, params = {}) {
  return getJson(`/api/decks/tournament/${encodeURIComponent(code)}${toQuery(params)}`);
}
